/* ============================================================
   2026 Feature Bar — inevifit-custom.js
   ============================================================ */

var IF2026 = IF2026 || {};

IF2026.featureBar = (function () {
  'use strict';

  function init() {
    // Accessible keyboard hover support for non-linked items
    var items = document.querySelectorAll('.if2026-fb__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var hasLink = item.querySelector('.if2026-fb__link-wrap');

      // Keyboard focus styles for non-linked items
      if (!hasLink) {
        item.setAttribute('tabindex', '0');
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            item.classList.toggle('if2026-fb__item--active');
          }
        });
      }

      // Touch tap feedback for mobile
      item.addEventListener('touchstart', function () {
        item.classList.add('if2026-fb__item--touch');
      }, { passive: true });

      item.addEventListener('touchend', function () {
        setTimeout(function () {
          item.classList.remove('if2026-fb__item--touch');
        }, 300);
      }, { passive: true });
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init if Shopify section is reloaded in theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.if2026-feature-bar')) {
      init();
    }
  });

  return { init: init };
})();


/* ============================================================
   2026 Card Grid — inevifit-custom.js
   ============================================================ */

IF2026.cardGrid = (function () {
  'use strict';

  function initVideos() {
    var videos = document.querySelectorAll('.if2026-cg__video');
    if (!videos.length) return;

    // IntersectionObserver — pause when out of view, play when in
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.paused) video.play().catch(function () {});
          } else {
            if (!video.paused) video.pause();
          }
        });
      }, { threshold: 0.25 });

      videos.forEach(function (video) {
        observer.observe(video);
      });
    } else {
      // Fallback: just attempt play on all autoplay videos
      videos.forEach(function (video) {
        if (video.autoplay) {
          video.play().catch(function () {});
        }
      });
    }
  }

  function init() {
    initVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify theme editor section load
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.if2026-card-grid')) {
      init();
    }
  });

  return { init: init };
})();
